<template>
  <div
    v-if="question"
    class="question-wrapper view"
    :style="{backgroundImage: `url(${bgImage})`}"
  >
    <fullscreen
      ref="fullscreen"
      background="#f9f9f9"
      :wrap="false"
      :style="{backgroundImage: `url(${bgImage})`}"
      class="full-area unselectable desktop-wrapper"
    >
      <transition-group
        name="slide" tag="div" class="full-area row-area"
      >
        <Screen
          :key="question.sys.id"
          :data="question"
          v-if="question && question.sys.contentType.sys.id === 'screen'"
          v-on:next="next($event)"
        ></Screen>
        <Bilderset
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'bilderset'"
          v-on:next="next($event)"
        ></Bilderset>
        <Dilemma
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'dilemma'"
          v-on:next="next($event)"
        ></Dilemma>
        <Thumbs
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'thumbs'"
          v-on:next="next($event)"
        ></Thumbs>
        <Emoji
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'emoji'"
          v-on:next="next($event)"
        ></Emoji>
        <Rating
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'rating'"
          v-on:next="next($event)"
        ></Rating>
        <Slider
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'slider'"
          v-on:next="next($event)"
        ></Slider>
        <DraggableSortList
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'draggableSortList'"
          v-on:next="next($event)"
        ></DraggableSortList>
        <Demographic
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'demographic'"
          v-on:next="next($event)"
        ></Demographic>
        <LikertBubbles
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'likertBubbles'"
          v-on:next="next($event)"
        ></LikertBubbles>
        <MultiTextSelection
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'multiTextSelection'"
          v-on:next="next($event)"
        ></MultiTextSelection>
        <EmojiSlider
          :data="question"
          :key="question.sys.id"
          :id="question.sys.id"
          v-if="question && question.sys.contentType.sys.id === 'emojiSlider'"
          v-on:next="next($event)"
        ></EmojiSlider>
      </transition-group>
    </fullscreen>
  </div>
</template>

<script>
export default {
  props: [ 'bgImage' ],

  name: 'Survey',

  components: {
    Screen: () => import('Components/questions/Screen'),
    Bilderset: () => import('Components/questions/Bilderset'),
    Dilemma: () => import('Components/questions/Dilemma'),
    Thumbs: () => import('Components/questions/Thumbs'),
    Emoji: () => import('Components/questions/Emoji'),
    Rating: () => import('Components/questions/Rating'),
    Slider: () => import('Components/questions/Slider'),
    DraggableSortList: () => import('Components/questions/DraggableSortList'),
    Demographic: () => import('Components/questions/Demographic'),
    LikertBubbles: () => import('Components/questions/LikertBubbles'),
    MultiTextSelection: () => import('Components/questions/MultiTextSelection'),
    EmojiSlider: () => import('Components/questions/EmojiSlider')
  },

  data () {
    return {
      fullscreen: false
    }
  },

  methods: {
    toggleFullscreen () {
      // Allow fullscreen only on production env
      if (process.env.NODE_ENV === 'production') {
        if (!this.fullscreen) {
          this.$refs.fullscreen.toggle()
          this.fullscreen = true
        }
      }
    },
    next (data) {
      this.$store.dispatch('STORE_RESPONSE', { response: data })
      this.toggleFullscreen()
      if (this.qid + 1 < this.$store.state.survey.questionCount) {
        this.$store.dispatch('NEXT_QUESTION')
      } else {
        this.$store.commit('SET_SURVEY_STATUS', { status: 'submit' })
        this.$router.push({ name: 'submit' })
      }
    },
    pushRoute () {
      if (this.status === 'started') {
        this.$router.push({ params: { sid: this.$route.params.sid, qid: this.current } })
      } else {
        this.$router.push({ name: status, params: { sid: this.$route.params.sid } })
      }
    }
  },

  computed: {
    question () {
      return this.$store.state.dataSet[parseInt(this.$route.params.qid, 10)]
    },
    current () {
      return this.$store.state.survey.current
    },
    qid () {
      return this.$store.state.survey.qid
    },
    submitted () {
      return this.$store.state.survey.submitted
    },
    status () {
      return this.$store.state.survey.status
    },
    surveyData () {
      return this.$store.state.dataSet
    }
  },

  mounted () {
    // Load the survey if not found when mounted.
    if (!this.surveyData.length) {
      this.$store.commit('CLEAR_FORM')

      if (this.$route.name === 'survey') {
        // this.$router.push({ name: 'survey', params: { sid: this.$route.params.sid, qid: 0 } })
      }
    }

    this.$store.commit('SET_ACTUAL_QID', { qid: parseInt(this.qid, 10) })

    /*
    // survey has started
    this.$store.commit('SET_SURVEY_STATUS', { status: 'started' })

    // What to do if the page is reloaded in the middle of it??
    if (this.$store.state.survey.status === 'started') {
      if (this.current !== parseInt(this.$route.params.qid, 10)) {
        // WIP What's this doing here??
        this.$router.push({ name: 'survey', params: { sid: this.$route.params.sid, qid: this.current } })
      }
    }

    if (this.$store.state.survey.status === 'sent') {
      this.$router.push({ name: 'results', params: { sid: this.$route.params.sid } })
    }

    if (this.$store.state.survey.status === 'submit') {
      this.$router.push({ name: 'submit', params: { sid: this.$route.params.sid } })
    }
    */
  },

  watch: {
    'current': function (newVal, oldVal) {
      this.pushRoute()

      // TODO
      // Improve this controller.
      // check qid and don't allow it to be higher than the number of responses... push route if that happens
      if (this.$store.state.survey.disallowBackButton) {
        if (this.current !== this.$store.state.responses.length + 1) {
          if (this.status === 'started') {
            this.$router.push({
              name: 'survey',
              params: {
                sid: this.$route.params.sid,
                qid: this.$store.state.responses.length
              }
            })
          } else {
            this.$router.push({ name: status })
          }
        }
      }
    },
    'qid': function (newVal) {
      this.$store.commit('SET_ACTUAL_QID', { qid: parseInt(newVal, 10) })
      this.$store.commit('SET_CURRENT', { current: parseInt(newVal, 10) })
    }
  }
}
</script>

<style scoped lang="scss">

.full-area,
.question-wrapper {
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
}
</style>
